import React from 'react';
import Button from '../../Shared/UI/Button/components/Button';

import { useUserIndexState, useUserIndexActions } from './UserIndexContext';
import { generateMatchScores, generateJobProspects } from './restApi';

import styles from './Index.module.scss';

const UsersTable = () => {
  const state = useUserIndexState();
  const { onResponse, onError } = useUserIndexActions();

  const goTouser = (user) => {
    window.location.assign(user.path);
  };

  const handleGenerateMatchScores = (user) => {
    generateMatchScores({
      userId: user.id,
      onResponse,
      onError,
    });
  };

  const handleGenerateJobProspects = (user) => {
    generateJobProspects({
      userId: user.id,
      onResponse,
      onError,
    });
  };

  if (!state?.users?.length) {
    return <p className={styles.noContentMessage}>No users.</p>;
  }

  return (
    <table id={styles.table}>
      <thead>
        <tr className={styles.tr}>
          <th className={styles.th}></th>
          <th className={styles.th}>Name</th>
          <th className={styles.th}>Primary Email</th>
          <th className={styles.th}>Is A Bot</th>
          <th className={styles.th}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {state?.users?.map(user => {
          return (
            <tr key={user.id} className={styles.tr}>
              <td className={styles.td}>
                <img id={styles.profilePicture} src={user.profilePicturePath} alt={user.name} />
              </td>
              <td className={styles.td}>{user.name}</td>
              <td className={styles.td}>{user.primaryEmail}</td>
              <td className={styles.td}>{user.isABot.toString()}</td>
              <td className={styles.td}>
                <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                  <Button
                    variant="primary"
                    onClick={() => goTouser(user)}
                  >
                    View Details
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={() => handleGenerateMatchScores(user)}
                  >
                    Generate Match Scores
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={() => handleGenerateJobProspects(user)}
                  >
                    Generate Job Prospects
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={() => window.location.assign(`/users/${user.id}/job_prospects`)}
                  >
                    Job Prospects
                  </Button>
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default UsersTable;
